$(document).ready(function () {

    var descriptionElement = document.getElementById('productDetailDescription');
    var description = $("#productDetailDescription").text();
  
    var originalDescription = descriptionElement.innerHTML;
  
    var lines =  description.split(/\r\n|\r|\n/).length;
    
    if(description.length > 200){
      var shortDescription = description.substr(0, 200) + "...";
      descriptionElement.innerHTML = shortDescription;
      $("#productDetailDescription").append("<a id='showMore' href='javascript:void(0);'><br/><br/>Read More</a>");
    }
  
  
    console.log("description length ==> ", description.length);
    console.log("line count ==> ", lines);
  
    console.log("original description ==> ", originalDescription);
  
    $( "#showMore" ).click(function() {
      var fieldNameElement = document.getElementById('productDetailDescription');
      descriptionElement.innerHTML = originalDescription;
      //alert( "Handler for .click() called." );
    });
  
  });
   